import React, { useContext, useMemo, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import { ChevronDown, ChevronUp, LogOut } from "lucide-react";
import { AppContext } from "../../context/AppContextProvider";
import reports from "../../assets/svg/reports.svg";
import survey from "../../assets/svg/survey.svg";
import cdm from "../../assets/svg/cdm.svg";
import tms from "../../assets/svg/tms.svg";
import overview from "../../assets/svg/overview.svg";
import assetsManagement from "../../assets/svg/assetsManagement.svg";
import gms from "../../assets/svg/gms.svg";
import socialMedia from "../../assets/svg/socialMedia.svg";
import directory from "../../assets/images/telephone.png";
import powerbi from "../../assets/images/powerbi.png";
import speech from "../../assets/images/speech2.png";
import event from "../../assets/images/event.png";
import { useTranslation } from "react-i18next";

const ElectionModeSidebar = ({ open, role }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleLogout } = useContext(AppContext);
  const [showMore, setShowMore] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  const menuItem = useMemo(() => {
    const items = [
      { id: 0, path: "/election-mode", name: t("Overview"), icon: overview },
      { id: 1, path: "/cdm", name: t("Constituency"), icon: cdm },
      { id: 2, path: "/gms", name: t("Grievance"), icon: gms },
      { id: 3, path: "/tms", name: t("Task"), icon: tms },
      { id: 4, path: "/eventScheduler", name: t("Calender Manager"), icon: event },
      { id: 5, path: "/reports", name: t("Reports"), icon: reports },
      { id: 6, path: "/survey", name: t("Surveys"), icon: survey },
      { id: 7, path: "/assets-management", name: t("Asset"), icon: assetsManagement },
      { id: 8, path: "/socialmedia", name: t("Social Media"), icon: socialMedia },
      { id: 9, path: "/chatModule", name: t("Chat Module"), icon: directory },
      { id: 10, path: "/speech-module", name: t("Speeches"), icon: speech },
    ];

    if (user?.powerBiLinks?.length > 0 && ["client", "chief_of_staff"].includes(user?.role)) {
      items.splice(10, 0, {
        id: 99,
        path: "/powerbi-module",
        name: t("Special Reports"),
        icon: powerbi,
      });
    }

    if (["data_entry_operator", "office_manager", "cadre"].includes(role)) {
      return items.filter((item) => ["/gms", "/tms", "/eventScheduler"].includes(item.path));
    }

    return items;
  }, [role, t, user?.powerBiLinks?.length, user?.role]);

  const visibleItems = menuItem.slice(0, 10);
  const hiddenItems = menuItem.slice(10);

  const renderItem = (item) => (
    <Tooltip placement="right" key={item.id} title={item.name}>
      <NavLink to={item.path} className="link sidebarLeft">
        {({ isActive }) => (
          <button
            type="button"
            className={`w-full flex items-center space-x-3 px-3 py-2 transition-all duration-200 rounded-xl ${
              isActive
                ? "text-white shadow-lg shadow-blue-600/25 bg-slate-700/80"
                : "text-slate-300 hover:bg-slate-700/80"
            }`}
          >
            <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
              <img src={item.icon} alt="" className="w-6 h-6" />
            </span>
            <span className="font-medium text-sm whitespace-nowrap">{item.name}</span>
          </button>
        )}
      </NavLink>
    </Tooltip>
  );

  // return (
  //   <aside className={`election-mode-sidebar ${open ? "open" : "closed"}`}>
  //     <div className="election-mode-sidebar-panel bg-black/70 shadow-2xl pt-2 rounded-2xl overflow-hidden">
  //       <div className="flex flex-col p-2 space-y-1">
  //         {visibleItems.map(renderItem)}

  //         {hiddenItems.length > 0 && (
  //           <button
  //             type="button"
  //             onClick={() => setShowMore((value) => !value)}
  //             className="flex items-center justify-center gap-2 text-slate-300 hover:text-white py-2"
  //           >
  //             {showMore ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
  //             <span className="text-sm">{showMore ? t("Show Less") : t("Show More")}</span>
  //           </button>
  //         )}

  //         <div className={`transition-all duration-300 overflow-hidden ${showMore ? "max-h-[900px]" : "max-h-0"}`}>
  //           {hiddenItems.map(renderItem)}
  //         </div>
  //       </div>

  //       <div className="p-2 border-t border-slate-700/50">
  //         <button
  //           type="button"
  //           onClick={() => {
  //             handleLogout();
  //             navigate("/");
  //           }}
  //           className="w-full flex items-center space-x-3 px-3 py-2 rounded-xl transition-all duration-200 text-slate-300 hover:bg-red-600/20 hover:text-red-400"
  //         >
  //           <LogOut className="w-4 h-4" />
  //           <span className="font-medium text-sm whitespace-nowrap">{t("Logout")}</span>
  //         </button>
  //       </div>
  //     </div>
  //   </aside>
  // );

  return (
  <div
    className={`election-mode-sidebar ${open ? "open" : "closed"} fixed left-6 top-[5.5rem] z-[999] transition-all duration-300 ease-in-out w-14`}
    onMouseLeave={() => {}}
  >
    <div
      className="bg-black/70 shadow-2xl pt-2 rounded-2xl overflow-hidden"
      style={{ borderRadius: "28px" }}
    >
      {/* Navigation Items */}
      <div className="flex flex-col p-2 space-y-1">
        {visibleItems.map((item) => (
          <Tooltip placement="right" key={item.id} title={item.name} overlayStyle={{ zIndex: 10000 }}
    getPopupContainer={(trigger) => trigger.parentNode}>
            <NavLink to={item.path} className="link">
              {({ isActive }) => (
                <button
                  type="button"
                  className={`w-full flex items-center justify-center py-2 transition-all duration-200 rounded-xl ${
                    isActive
                      ? "text-white shadow-lg shadow-blue-600/25 bg-slate-700/80"
                      : "text-slate-300 hover:bg-slate-700/80"
                  }`}
                >
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                    <img src={item.icon} alt="" className="w-6 h-6" />
                  </span>
                </button>
              )}
            </NavLink>
          </Tooltip>
        ))}

        {/* Show More */}
        {hiddenItems.length > 0 && (
          <Tooltip
            placement="right"
            title={showMore ? t("Show Less") : t("Show More")}
            overlayStyle={{ zIndex: 10000 }}
    getPopupContainer={(trigger) => trigger.parentNode}
          >
            <button
              type="button"
              onClick={() => setShowMore((value) => !value)}
              className="flex items-center justify-center text-slate-300 hover:text-white py-2 rounded-xl hover:bg-slate-700/80 transition-all duration-200"
            >
              {showMore ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </button>
          </Tooltip>
        )}

        {/* Hidden Items */}
        <div
          className={`transition-all duration-300 overflow-hidden ${
            showMore ? "max-h-[900px]" : "max-h-0"
          }`}
        >
          <div className="flex flex-col space-y-1">
            {hiddenItems.map((item) => (
              <Tooltip placement="right" key={item.id} title={item.name} overlayStyle={{ zIndex: 10000 }}
    getPopupContainer={(trigger) => trigger.parentNode}>
                <NavLink to={item.path} className="link">
                  {({ isActive }) => (
                    <button
                      type="button"
                      className={`w-full flex items-center justify-center py-2 transition-all duration-200 rounded-xl ${
                        isActive
                          ? "text-white shadow-lg shadow-blue-600/25 bg-slate-700/80"
                          : "text-slate-300 hover:bg-slate-700/80"
                      }`}
                    >
                      <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                        <img
                          src={item.icon}
                          alt=""
                          className="w-6 h-6"
                        />
                      </span>
                    </button>
                  )}
                </NavLink>
              </Tooltip>
            ))}
          </div>
        </div>
      </div>

      {/* Logout */}
      <Tooltip placement="right" title={t("Logout")} overlayStyle={{ zIndex: 10000 }}
    getPopupContainer={(trigger) => trigger.parentNode}>
        <div className="p-2 border-t border-slate-700/50">
          <button
            type="button"
            onClick={() => {
              handleLogout();
              navigate("/");
            }}
            className="w-full flex items-center justify-center py-2 rounded-xl transition-all duration-200 text-slate-300 hover:bg-red-600/20 hover:text-red-400"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </Tooltip>
    </div>
  </div>
);
};

export default ElectionModeSidebar;
